<script lang="ts" setup>
import { onMounted, useTemplateRef } from 'vue';
import * as dashjs from 'dashjs';

const props = defineProps<{
  url: string;
  // optional dash or video?
  // optional fallback to hls
}>();

const elVideo = useTemplateRef('elVideo');

onMounted(() => {
  if (elVideo.value) {
    const player = dashjs.MediaPlayer().create();
    player.initialize(elVideo.value, props.url, false);
  }

  //   if (dashjs.supportsMediaSource()) {
  //   player.src = attachment.mpd_url;
  // } else {
  //   video.src = attachment.hls_url;
  // }
});
</script>

<template>
  <video ref="elVideo" controls muted></video>
</template>
